import React, { useContext } from "react";
import styles from "./AuthLayout.module.css";
import { Box, Paper, Typography } from "@mui/material";
import AppContext from "../../../context/AppContext";

export const AuthLayout: React.FC<{
  title: string;
  maxWidth: string;
  footer?: React.ReactNode;
  isAnnouncementAvai?: boolean;
  heading?: string;
  hideHeading?: boolean;
  children?: React.ReactNode;
  doNotShow?: boolean;
}> = ({ title, maxWidth, children, footer, isAnnouncementAvai, heading, hideHeading, doNotShow }) => {
  const isDesktop = useContext(AppContext).isDesktop;

  return (
    <Box
      px={[0, 2]}
      mx={[0, "auto"]}
      className={isDesktop && isAnnouncementAvai ? styles.fullpageA : styles.fullPage}
      mt={3}
      maxWidth={maxWidth}
    >
      <Paper className={!doNotShow ? styles.fullWidth : styles.fullWidthMobile}>
          <Box py={hideHeading ? 0 : 8} width={"100%"}>
            {!doNotShow && !hideHeading && (
              <Box className={styles.productLabel} bgcolor="primary.main" py={1} pl={[2, 4]}>
                <Typography variant="h4">
                  {heading ? (
                    heading
                  ) : (
                    <>
                      <b>eResults</b> Viewer
                    </>
                  )}
                </Typography>
              </Box>
            )}
            <Box px={[2, 4]} mt={!doNotShow ? 3 : 5}>
              <Typography variant="h3">{title}</Typography>
              {children}
            </Box>
          </Box>
      </Paper>
      {!doNotShow && footer}
    </Box>
  );
};

export default AuthLayout;
